const failureCodeOf = (error)=>{
    const code = error instanceof Error && 'code' in error ? error.code : undefined;
    return typeof code === 'string' ? code : 'unknown';
};
export const makeNativeSaveFile = (files, reportFailure)=>{
    if (!files.isAvailable) return undefined;
    const saveAndReport = async (blob, filename)=>{
        try {
            await files.save(blob, filename);
        } catch (error) {
            reportFailure(new Error("native-save-file-failed: ".concat(failureCodeOf(error))));
            throw error;
        }
    };
    const pending = {
        save: null
    };
    // WHY: the system save dialog is modal, so a second save before it settles can only be a repeated tap.
    return (blob, filename)=>{
        var _pending, _save;
        (_save = (_pending = pending).save) !== null && _save !== void 0 ? _save : _pending.save = saveAndReport(blob, filename).finally(()=>{
            pending.save = null;
        });
        return pending.save;
    };
};
